import { render, staticRenderFns } from "./marketPrices.vue?vue&type=template&id=545db1df"
import script from "./marketPrices.vue?vue&type=script&lang=js"
export * from "./marketPrices.vue?vue&type=script&lang=js"
import style0 from "./marketPrices.vue?vue&type=style&index=0&id=545db1df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports